
    import I18n from 'i18nObj';
    
      import 'translations/calendar_color_picker';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('calendar_color_picker');
  